<template>
  <div class="launchpack-delivery">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    ></admin-filter>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(`${props.item.order.id}&page=OrderListCancelNew`)" class="unselect" style="text-decoration:underline">{{ props.item.id }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.name }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div class="flex align-center">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px" v-if="props.item.product.img">
          <div style="text-align: left">
            <div v-if="props.item.order_product_option.length>0">
              <div>{{ props.item.product.name }}</div>
              <div
                v-for="(option, option_idx) in props.item.order_product_option"
                :key="'option-'+option_idx">
                <span v-if="option.option.option_type===0">기본옵션:</span>
                <span v-if="option.option.option_type===1">추가옵션:</span>
                {{ optionFullName(option) }}
              </div>
            </div>
            <div v-else>
              {{ props.item.product.name }}
            </div>
          </div>
        </div>
      </td>

      <!-- 수량 -->
      <td slot="quantity" slot-scope="props">{{ props.item.quantity }}</td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배송 금액 -->
      <td slot="delivery_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.delivery_cost | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.total_price | currency }}</td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props">
        <div v-if="props.item.partner">{{ props.item.partner }}</div>
        <div v-else>-</div>
      </td>

      <!-- 취소사유 -->
      <td slot="reason" slot-scope="props">{{ props.item.reason }}</td>

      <!-- 상태 -->
      <td slot="status_kor" slot-scope="props">{{ props.item.status_kor }}</td>

      <!-- 상태 변경 -->
      <td slot="status_change" slot-scope="props">
        <!-- 취소요청 : 상태변경 - [승인] [보류] -->
        <template v-if="props.item.status===500">
          <button class="button" style="width:130px" @click="changeStatus(props.item, 501)">취소승인(환불대기)</button>
          <button class="button" style="width:130px;margin-top:4px" @click="changeStatus(props.item, 502)">취소보류</button>
        </template>
        <!-- 취소승인 : 상태 - [환불 처리] -->
        <template v-else-if="props.item.status===501">
          <button class="button" style="width:80px" @click="clickRefund(props.item)">환불처리</button>
        </template>
        <!-- 취소보류 : 상태 - [요청][승인] -->
        <template v-if="props.item.status===502">
          <button class="button" style="width:130px" @click="changeStatus(props.item, 500)">취소요청(승인대기)</button>
          <button class="button" style="width:130px;margin-top:4px" @click="changeStatus(props.item, 501)">취소승인(환불대기)</button>
        </template>
      </td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type }}</span></td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리</button>
        </div>
      </div>
    </order-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>취소승인(환불대기) 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <modal name="cancelDelayModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="취소 보류 처리" :useTab="false" class="lp-modal-wrapper">
        <div>취소보류 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelDelayModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelDelayModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <!-- 환불 모달 -->
    <modal name="refundModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <order-cancel-refund class="lp-modal-wrapper"
                    :order="selectedRefundProduct"
                    :refund_id="selectedRefundId"
                    @confirm="confirm('refundModal')"
                    @close="$modal.hide('refundModal')"></order-cancel-refund>
    </modal>

<!--    500 취소요청-->
    <modal name="cancelRequestModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>취소요청(승인대기) 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelRequestModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelRequestModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <modal name="cancelWithDrawModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>취소요청철회 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelWithDrawModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelWithDrawModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import OrderCancelRefund from "../components/OrderCancelRefund";
  import DeliveryMixin from "@/mixins/DeliveryMixin"

  export default {
    name: 'OrderListCancelNew',
    components: {LpCheckBool, OrderCancelRefund},
    mixins: [
      DeliveryMixin
    ],
    data() {
      return {
        value: undefined,
        selectedRefundId: 0,
        selectedRefundProduct: undefined
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // (테이블 필드, 사용할 api, 현재페이지)
        this.initializing('cancel_new', 'delivery/orderproduct?start_status=500&end_status=502', 'OrderListCancelNew');
      },
      getDataFromServer() {
        this.getData();
      },
      confirm (modal_name) {
        this.getData();
        this.$modal.hide(modal_name);
      },
      clickRefund(val) {
        this.checkArr.filter(item => { return item.id === val.id })[0].value = true;
        this.selectedRefundProduct = val;
        this.status = 506;
        this.clickChange();
      },
      changeStatus(val, status) {
        this.checkArr.filter(item => { return item.id === val.id })[0].value = true;
        this.status = status;
        this.clickChange();
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb
</style>
